module.exports = __webpack_public_path__ + "static/media/порог школы 2.09f77055.jpg";